(ns ycweb.app.website.myaccount.aftersales.create
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;Aftersales Validate Create ====================================================================================================================================

(defn validate-item [app-atom aftersale-type item]
  (let [perishable? (:client-order-item/perishable? item)
        selected-qty (or (:aftersale-item/selected-qty item) 1)
        damaged-reason-codes
        (filter
          #(= (:fault/reason-code %) 0)
          (vals (:aftersale-item/faults item)))

        reason-code-count
        (count
          (filter
            #(u/presence (:fault/reason-code  %))
            (vals (:aftersale-item/faults item))))
        reason-text-count
        (count
          (filter
            #(u/presence (:fault/reason-text  %))
            (vals (:aftersale-item/faults item))))

        reason-given?
        (and
          (= reason-text-count selected-qty)
          (cond
            (= aftersale-type :repair)
            (u/presence (map :fault/usage-type (vals (:aftersale-item/faults item))))

            (= aftersale-type :return)
            (= reason-code-count selected-qty)))

        valid?
        (and
          reason-given?
          (or
            (= (count damaged-reason-codes) selected-qty)
            (not perishable?)))]

    {:id (:ent/uuid item)
     :validation-check
     {:valid? valid?
      :msg
      (cond
        valid?
        ""

        perishable?
        [:span "Sorry, you cannot return perishable items. "
         [:br]
         [:a.text-link
          (merge
            (urlstate/href-props app-atom "help" "article" {:id 155})
            {:target "_blank"})
          "See returns policy."]]

        (not reason-given?)
        "Please fill in all the fields to submit a return.")}}))

(defn validate-item-forms [app-atom aftersale-type items]
  (let [validated-items (map #(validate-item app-atom aftersale-type %) items)
        invalid-items (remove #(:valid? (:validation-check %)) validated-items)
        valid-form?
        (and
          (not (empty? items))
          (not (empty? validated-items))
          (empty? invalid-items))]

    {:valid-form? valid-form?
     :invalid-items validated-items}))

(defmethod grid/action :web.myaccount.aftersale/items-validate [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale (:aftersale config)
        aftersale-type (:aftersale/type aftersale)
        valid
        (->> (:aftersale/items aftersale)
          (map second)
          (filter :selected)
          (validate-item-forms app-atom aftersale-type))

        aftersale-items-atom (rum/cursor-in process-atom [:aftersale :aftersale/items])
        response-map
        (doseq [{:keys [id validation-check]} (:invalid-items valid)]
          (swap! aftersale-items-atom assoc-in [id :validation] validation-check))]

    (if-not (:valid-form? valid)
      (swap! process-atom assoc :aftersale/items response-map)
      (t/transition-next app-atom :web.myaccount/aftersale-confirm))))

;Aftersales Create ====================================================================================================================================

(rum/defc return-order-form < rum/reactive [app-atom aftersale-atom client-order-item reason-codes aftersale-validation]
  (let [aftersale-valid (cmn/curact aftersale-validation [])
        selected-atom (rum/cursor-in aftersale-atom [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/selected-qty])

        {:client-order-item/keys [available-qty qty-shipped]} client-order-item
        qty-all-returnable? (= qty-shipped available-qty)
        qty-returnable-diff (- available-qty qty-shipped)]

    [:tr.yc-tr.yc-tr--form {:style {:display "table-row;"}}
     [:td.yc-td]
     [:td.yc-td {:colspan "5"}

      (when (not qty-all-returnable?)
        (feedback/feedback :warning
          (str (if (= 1 qty-returnable-diff)
                 "One of the items"
                 "Some of these items")
            " cannot be returned, as "
            (if (= 1 qty-returnable-diff)
              "it has not"
              "they have not")
            " been shipped yet.")
          [:span "For assistance, please contact "
           [:a.text-link
            {:href "mailto: hello@yuppiechef.com"}
            "hello@yuppiechef.com"] " or "
           [:a.text-link
            {:href "tel:+27217024969"}
            "+27 (0)21 702 4969"] "."]))

      (when (> available-qty 1)
        [:div.form.u-max-width-240
         (forms/select "How many of this item are you returning:" selected-atom
           (map
             (fn [q]
               {:text (str (inc q))
                :value (inc q)})
             (range qty-shipped))
           {:type :number})])

      (for [x (range (or (rum/react selected-atom) 1))]
        [:div.form.u-max-width-480
         [:div.js-aftersales-item-form
          (when (> available-qty 1)
            [:p [:b "Item " (inc x)]])
          (when
            (and
              (not (nil? (:valid? aftersale-valid)))
              (not (:valid? aftersale-valid)))
            (feedback/feedback :error
              [:span
               (:msg aftersale-valid)]
              {}))
          (forms/select "Reason for return:"
            (rum/cursor-in aftersale-atom
              [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/reason-code])
            (into
              [{:text "Please select"
                :value ""}]
              (map
                (fn [{:reason/keys [code text] :as reason}]
                  {:text text
                   :value code})
                reason-codes))

            {:type :number
              ;; TODO: needs link on see definitions
             :hint "See definitions of possible reasons for return."})

          (forms/textarea "Please provide a summary of what went wrong:"
            (rum/cursor-in aftersale-atom [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/reason-text])
            {:id :caseitems_reasontext
             :name :caseitems_reasontext
             :rows "4"})]])]]))

(rum/defc repair-order-form < rum/reactive [app-atom aftersale-atom client-order-item]
  (let [selected-atom (rum/cursor-in aftersale-atom [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/selected-qty])
        {:client-order-item/keys [available-qty]} client-order-item]
    [:tr.yc-tr.yc-tr--form {:style {:display "table-row;"}}
     [:td.yc-td]
     [:td.yc-td {:colspan "5"}

      (when (> available-qty 1)
        [:div.form.u-max-width-240
         (forms/select "How many of this item are you returning:" selected-atom
           (map
             (fn [q]
               {:text (str (inc q))
                :value (inc q)})
             (range available-qty))
           {:type :number})])

      (for [x (range (or (rum/react selected-atom) 1))]
        [:div.form.u-max-width-480
         [:div
          (when (> available-qty 1)
            [:p [:b "Item " (inc x)]])

          (forms/input "Serial number: (optional)" ""
            (rum/cursor-in aftersale-atom
              [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/serial-number])
            {:hint "Usually found underneath item, by power cable or packaging. See examples"})

          [:div.form-field
           (forms/radio "Domestic Use" "Domestic"
             (rum/cursor-in aftersale-atom
               [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/usage-type])
             {:description "You use the appliance to cook at home for you and your family.
             The appliance is used daily, catering for approximately 6 people."})]
          [:div.form-field
           (forms/radio "Commercial Use" "Commercial"
             (rum/cursor-in aftersale-atom
               [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/usage-type])
             {:description "The appliance is used in a shop, café, restaurant, tuckshop or office,
             for home industry or in the hospitality industry."})]
          (forms/textarea "Please describe the fault:"
            (rum/cursor-in aftersale-atom
              [:aftersale/items (:ent/uuid client-order-item) :aftersale-item/faults (str x) :fault/reason-text])
            {:id :caseitems_reasontext
             :name :caseitems_reasontext
             :rows "4"})]])]]))

;;Discontinued support for BOM - it was not included in the port from PHP
(rum/defc orderitem-view-line < rum/reactive [app-atom client-order client-order-item]
  (let [process-atom (cmn/process-cursor app-atom)
        aftersale-atom (rum/cursor-in process-atom [:aftersale])
        selected-atom (rum/cursor-in aftersale-atom [:aftersale/items (:ent/uuid client-order-item) :selected])
        aftersale-type (:aftersale/type (rum/react process-atom))
        aftersale-validation (rum/cursor-in aftersale-atom [:aftersale/items (:ent/uuid client-order-item) :validation])
        reason-codes (cmn/curact process-atom [:reason-codes])

        {:client-order/keys [has-bundle-up?]} client-order
        {:item-line/keys [product variation qty]
         :client-order-item/keys [price available-qty bundle-discount-amount total-price existing-return-case-items qty-shipped]} client-order-item
        bundle-discount-amount (or bundle-discount-amount 0)

        {:variation/keys [feature1 feature2 display-pack-size pack-description code]} variation

        multi-pack? (and display-pack-size (> display-pack-size 1))
        has-feature? (or (u/presence feature1) (u/presence feature2))]
    (list
      [:tr.yc-tr
       [:td
        {:class (u/bem :yc-td [:product-image])}
        (web-common/lazy-image app-atom (:doc/public-id (:ent/image variation)) {:class ["yc-td__image"]} {:w 100 :h 100})]

       [:td
        {:class (u/bem :yc-td [:product-text])}

        [:div.yc-td__product-name (:ent/display-name product)]
        (when (or has-feature? multi-pack?)
          [:div.yc-td__product-description
           (when multi-pack? [:b (str pack-description " of " display-pack-size)])
           (when (and multi-pack? has-feature?) [:span.u-pipe " | "])
           (cond
             (and (u/presence feature1) (u/presence feature2)) (str feature1 ", " feature2)
             (u/presence feature1) feature1
             (u/presence feature2) feature2)
           [:span.u-pipe " | "]
           [:span.yc-table__clip-text "Product "]
           (str "Code: " code)])
        (when (zero? qty-shipped)
          [:span.u-block.text-status--warning
           [:b "Note:"] " This item can not be returned as it has not shipped yet."])

        (map
          (fn [{:return-case-item/keys [case-status status] :as caseItem}]
            [:div.yc-td__product-notes
             [:span.text-status--error
              [:b "Existing " (:return-case-item/type caseItem) " case " (:return-case/display-name caseItem)]
              [:br]
              case-status ", Item status: " status]])
          existing-return-case-items)]

       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span.yc-td__faux-table {:data-th "Qty"}
         [:span.yc-td__faux-td qty]]]

       [:td.yc-td
        [:span.yc-td__faux-table {:data-th "Price"}
         [:span.yc-td__faux-td (str "R" (u/currency-format price))]]]

       (when has-bundle-up?
         [:td.yc-td
          (when (> bundle-discount-amount 0)
            [:span.yc-td__faux-table {:data-th "Discount"}
             [:span.yc-td__faux-td.u-text-red (str "-" "R" (u/currency-format bundle-discount-amount))]])])

       [:td.yc-td
        [:span.yc-td__faux-table {:data-th "Total"}
         [:span.yc-td__faux-td
          (str "R"
            (if (> bundle-discount-amount 0)
              (u/currency-format (- total-price bundle-discount-amount))
              (u/currency-format total-price)))]]]

       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span.yc-td__faux-table {:data-th (if (= aftersale-type :repair) "Repair" "Return")}
         [:span.yc-td__faux-td

          (when
            (> available-qty 0)
            (forms/checkbox "" selected-atom
              {:id :selected
               :name :radio
               :disabled
               (zero? qty-shipped)
               :inline true}))]]]]

      (cond
        (and (= aftersale-type :repair) (rum/react selected-atom) (> available-qty 0))
        (repair-order-form app-atom aftersale-atom client-order-item)
        (and (= aftersale-type :return) (rum/react selected-atom) (> available-qty 0))
        (return-order-form app-atom aftersale-atom client-order-item reason-codes aftersale-validation)))))

(rum/defc order-view-line < rum/reactive [app-atom order item]
  (orderitem-view-line app-atom order item))

(rum/defc order-bundle-items-view [app-atom has-bundle-up? client-order [bundle-group-number group-items]]
  (list
    [:tr.yc-tr.yc-tr--section-title
     (cond
       (and bundle-group-number (pos? bundle-group-number))
       [:td.yc-td {:colSpan "7"} [:b (str "Special bundle " bundle-group-number ":")]]
       has-bundle-up?
       [:td.yc-td {:colSpan "7"} [:b "Other items in this order:"]])]
    (map (partial order-view-line app-atom client-order) group-items)))

(rum/defc aftersale-order-table < rum/reactive [app-atom client-order]
  (let [process-atom (cmn/process-cursor app-atom)

        aftersale-type (:aftersale/type (rum/react process-atom))
        {:ent/keys [display-name]
         :client-order/keys [items has-bundle-up?]} client-order]

    [:table.yc-table.yc-table--order-view
     [:caption.yc-table-caption.hidden-from-view (str "Arrange a " (if (= aftersale-type :repair) "repair" "return") " on item(s) from your order " display-name " below")]
     [:colgroup
      [:col {:width "100"}]
      [:col]
      [:col]
      [:col]
      [:col]
      [:col {:width "100"}]]
     [:thead.yc-thead
      [:tr.yc-tr
       [:th.yc-th {:scope "col"} "Item"]
       [:th.yc-th {:scope "col"} "Description"]
       [:th.yc-th.yc-th--centered {:scope "col"}
        "Qty"]
       [:th.yc-th {:scope "col"} "Price"]
       (when has-bundle-up? [:th.yc-th {:scope "col"} "Discount"])
       [:th.yc-th {:scope "col"} "Total"]
       [:th.yc-th.yc-th--centered {:scope "col"} (if (= aftersale-type :repair) "Repair" "Return")]]]
     [:tbody.yc-tbody
      (concat
        (cond
          has-bundle-up?
          (map (partial order-bundle-items-view app-atom has-bundle-up? client-order) (group-by :client-order-item/bundle-group-number items))
          :else
          (map (partial order-view-line app-atom client-order) items)))]]))

(rum/defc aftersale-order < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)

        order (cmn/curact process-atom [:client-order])
        aftersale (cmn/curact process-atom [:aftersale])
        aftersale-type (cmn/curact process-atom [:aftersale/type])

        available-count (reduce + 0 (map :client-order-item/available-qty (:client-order/items order)))]
    [:div.dashboard
     (headings/heading
       (str "Arrange a " (if (= aftersale-type :repair) "Repair" "Return") " - "
         (:ent/display-name order))
       {:type :h2 :size :medium})
     [:form {:action "" :method "post"}
      (when (:client-order/has-bundle-up? order)
        (feedback/feedback
          :info "This order had bundle up special items."
          [:span "Because your order had items from a bundle up special, the value of the free item is divided and applied
          equally as a discount across all the items in that bundle. "
           [:a.text-link.js-mfp-open-url
            {:href "/help.htm?action=article&id=243"
             :data-title "<b>Returns policy for bundle discount specials</b>"
             :data-content-wrapper-class "yc-simple-text"
             :target_url "/help.htm?action=article&id=243&overrideincludes=blank"}
            "Learn more."]]))

      (aftersale-order-table app-atom order)
      [:div.dashboard-footer
       (buttons/button-web "Cancel"
         (merge
           (urlstate/href-props app-atom "myaccount" (if (= aftersale-type :repair) "createrepair" "createreturn"))
           {:style :negative :size :default}))

       (when (> available-count 0)
         (buttons/button-web "Save and next"
           {:on-click
            #(grid/dispatch-action app-atom :web.myaccount.aftersale/items-validate {:aftersale aftersale})
            :type :button
            :style :primary
            :size :default}))]]
     (toaster/loading-overlay app-atom :web.myaccount/aftersalecreate)]))

(defmethod flow/render-screen :web.myaccount/aftersalecreate [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersale-order app-atom)))

(defmethod urlstate/screen-params-shape :web.myaccount/aftersalecreate [_]
  {:casetype :keyword})

(defmethod t/transition-open :web.myaccount/aftersalecreate [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [casetype]} params]
    (swap! process-atom assoc :aftersale/type casetype)
    (toaster/open-overlay app-atom :web.myaccount/aftersalecreate)
    (comms/ajax-get :web.myaccount/aftersalesclientorder (select-keys params [:uuid]))))

(defmethod comms/receive :web.myaccount/aftersalesclientorder [app-atom e]
  (let [client-order (:client-order e)
        delivery-address (:client-order/delivery-details client-order)
        delivery-contact (:delivery/contact delivery-address)

        process-atom (cmn/process-cursor app-atom)

        aftersale-items
        (u/index-by :ent/uuid (:client-order/items client-order))

        current-aftersale (:aftersale @process-atom)
        case-type (:aftersale/type @process-atom)
        order-match? (= (:ent/uuid client-order) (:client-order/uuid current-aftersale))

        aftersale
        (cond
          (and order-match? (> (count (:aftersale/items current-aftersale)) 0))
          current-aftersale
          :else
          #:aftersale
           {:ent/uuid (:case-uuid e)
            :client-order/uuid (:ent/uuid client-order)
            :items aftersale-items
            :type case-type
            :contact
            #:contact
             {:name (:contact/name delivery-contact)
              :email (:contact/email delivery-contact)
              :number (:contact/tel delivery-contact)}
            :collection
            #:collection
             {:address
              #:address
               {:address (:delivery/address delivery-address)
                :suburb (:delivery/suburb delivery-address)
                :city (:delivery/city delivery-address)
                :postal-code (:delivery/postal-code delivery-address)}}})]
    (swap! (cmn/process-cursor app-atom)
      #(assoc %
         :aftersale aftersale
         :reason-codes (:reason-codes e)
         :client-order client-order)))
  (toaster/close-overlay app-atom :web.myaccount/aftersalecreate))